import { parseResponse } from  '../../../helpers/api'
import client from '../../../client'

export default {
    async getUserInfo () {
        return client.common.get(`/user/info`).then((response) => {
            return parseResponse(response)
        })
    },
    async login (email, password, language) {
        return client.common.post(`/login`, {
            email: email,
            password: password,
        }, {
            headers: {
                'X-Request-Language': language
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async logout() {
        return client.common.post(`/logout`).then((response) => {
            return parseResponse(response)
        })
    }
}